import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { deleteField, doc, Firestore, setDoc, updateDoc } from 'firebase/firestore'
import { IPackagesRepository } from './packages'

export class PackagesRepositoryFirebase implements IPackagesRepository {
  constructor(private readonly userId: string, private readonly firestore: Firestore) {}

  addPackage(pkg: PackageModel) {
    return this.upsertPackage(pkg)
  }

  addMultiplePackages(pkgs: PackageModel[]) {
    const docRef = this.getDocRef()

    let docChanges = {}

    pkgs.forEach(pkg => {
      docChanges[`packages.${pkg.computedKey}`] = pkg.serializeToFirestoreDocument()
    })

    return updateDoc(docRef, docChanges)
  }

  updatePackage(pkg: PackageModel, changes: Partial<PackageModel>) {
    const updated = pkg.edit(changes)
    const docRef = this.getDocRef()

    let docChanges

    if (updated.computedKey !== pkg.computedKey) {
      // Different keys means the extradata changed
      // we need to remove the old package because its like
      // we're adding a new package
      docChanges = {
        [`packages.${pkg.computedKey}`]: deleteField(),
        [`packages.${updated.computedKey}`]: updated.serializeToFirestoreDocument(),
      }
    } else {
      docChanges = {
        [`packages.${updated.computedKey}`]: updated.serializeToFirestoreDocument(),
      }
    }

    return updateDoc(docRef, docChanges)
  }

  toggleCollapsePackage(pkg: PackageModel) {
    return this.upsertPackage(pkg.edit({ collapsed: !pkg.collapsed }))
  }

  addSortFieldLastStateDate(pkg: PackageModel, dateInMs: number) {
    const updated = pkg.updateOrder(dateInMs)

    if (updated !== pkg) {
      // new reference means the value was updated
      // we need to save it
      return this.upsertPackage(updated)
    }
  }

  removePackage(pkg: PackageModel): Promise<void> {
    const docRef = this.getDocRef()

    return setDoc(
      docRef,
      {
        packages: {
          [pkg.computedKey]: deleteField(),
        },
      },
      { merge: true }
    )
  }

  private getDocRef() {
    return doc(this.firestore, 'users', this.userId)
  }

  private upsertPackage(pkg: PackageModel) {
    const docRef = this.getDocRef()

    return updateDoc(docRef, {
      [`packages.${pkg.computedKey}`]: pkg.serializeToFirestoreDocument(),
    })
  }
}
